import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { toDateParseTCompact, toDateTimeCompact } from "../../../utils/datesHeures";
import { apiGetProcesses } from "../../../api/ApiProcess";
import { apiGetEmissions } from "../../../api/ApiEmission";
import { apiGetPublications } from "../../../api/ApiPublication";
import bandeauContribution from "../../../assets/images/bandeauContribution.jpg";
import { BiMessageDetail } from "react-icons/bi";
import {
  apiGetLastContribsOnEspacesColidee,
  apiRecupActualitesColidee,
} from "../../../api/ApiColidee";
import bandeauActualite from "../../../assets/images/bandeauActualite.jpg";
import bandeauEmission from "../../../assets/images/bandeauEmission.jpg";
import bandeauPublication from "../../../assets/images/bandeauPublication.jpg";
import bandeauPublicationSmall from "../../../assets/images/bandeauPublicationSmall.jpg";
import { Image } from "react-bootstrap";
import ComponentTitle from "../../layout/ComponentTitle";
import ComponentLoader from "../../layout/ComponentLoader";
import { toDateTimeFR, toDateParseFR } from "../../../utils/datesHeures";

import illustrationEmission from "../../../assets/extensions/video.png";
import illustrationPodcast from "../../../assets/extensions/audio.png";
import ComponentThemesContribution from "../colidee/ComponentThemesContribution";
import ComponentTitleAndSousTitle from "../../layout/ComponentTitleAndSousTitle";

const BlocEpingle4 = () => {
  const { t } = useTranslation();
  const anteriorite = 60;
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxToken } = useSelector((state) => state.ReduxToken);
  const [datas, setDatas] = useState([]);
  const [alldatas, setAllDatas] = useState([]);
  const [focusPrimaire, setFocusPrimaire] = useState();
  const [focusSecondaire, setFocusSecondaire] = useState([]);
  const [loader, setLoader] = useState(false);

  /* Recup des idées sur Colidée */
  const recupGlobal = async () => {
    var espacesSouhaites = [];
    var retour = [];
    const form = new FormData();

    const resProcesses = await apiGetProcesses(ReduxInstance._id, "filter[famille]=MacroProcess");
    resProcesses.data.map(
      (process) => (espacesSouhaites = espacesSouhaites.concat(process.espaces))
    );
    espacesSouhaites = espacesSouhaites.filter((x, i, a) => a.indexOf(x) === i);

    if (ReduxInstance.espacePrincipalColidee) {
      espacesSouhaites = espacesSouhaites.filter(
        (item) => parseInt(item) !== ReduxInstance.espacePrincipalColidee
      );
    }

    form.append("espacesSouhaites", espacesSouhaites.join(","));
    form.append("entreprises", ReduxInstance.entreprisesColidee.join(","));

    /* recup Actualites COLIDEE */
    const resColideeActualites = await apiRecupActualitesColidee(ReduxToken, form);
    /* recup contributionsColidée  */
    const resColideeContributions = await apiGetLastContribsOnEspacesColidee(ReduxToken, form);

    /* recup Emissions EASYGOUV */
    const resEmissions = await apiGetEmissions(
      ReduxInstance._id,
      "filter[publie]=true&filter[datePublication][$exists]=true"
    );
    /* recup Publications EASYGOUV */
    const resPublications = await apiGetPublications(
      ReduxInstance._id,
      "filter[publie]=true&filter[datePublication][$exists]=true"
    );

    if (resEmissions.data || resPublications.data) {
      let focusPrimaireSearch = "";
      let focusSecondaireSearch = [];

      resEmissions.data.forEach((emission, index) => {
        if (emission.focusPrimaire) {
          focusPrimaireSearch = {
            date: toDateParseTCompact(emission.datePublication),
            type: "emission",
            data: emission,
          };
        }
        if (emission.focusSecondaire) {
          focusSecondaireSearch.push({
            date: toDateParseTCompact(emission.datePublication),
            type: "emission",
            data: emission,
          });
        }
      });

      resPublications.data.forEach((publication, index) => {
        if (publication.focusPrimaire) {
          focusPrimaireSearch = {
            date: toDateParseTCompact(publication.datePublication),
            type: "publication",
            data: publication,
          };
        }
        if (publication.focusSecondaire) {
          focusSecondaireSearch.push({
            date: toDateParseTCompact(publication.datePublication),
            type: "publication",
            data: publication,
          });
        }
      });

      setFocusPrimaire(focusPrimaireSearch);
      setFocusSecondaire(focusSecondaireSearch);
    }

    retour.actualites = resColideeActualites.data;
    retour.contributions = resColideeContributions.data;
    retour.emissions = resEmissions.data;
    retour.publications = resPublications.data;

    setAllDatas(retour);
  };

  function urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function (url) {
      return url.substring(0, url.indexOf("/", 7) > 0 ? url.indexOf("/", 7) : url.length);
    });
  }

  const filtreDatas = async () => {
    var now = new Date();
    // on calcule la date UNIX 30 jours avant
    var nomMoinsAnteriorite = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - anteriorite
    );
    /* oni calcule la date de l'anteriorite pour pouvoir la comparer à la date de l'event et à la date d'embauche */
    var dateAnteriorite =
      nomMoinsAnteriorite.getFullYear() +
      "" +
      ("0" + (nomMoinsAnteriorite.getMonth() + 1)).slice(-2) +
      "" +
      ("0" + nomMoinsAnteriorite.getDate()).slice(-2);

    var classement = [];

    if (alldatas.actualites) {
      alldatas.actualites.forEach((item) => {
        if (
          item.date_publication &&
          toDateParseTCompact(item.date_publication) >= dateAnteriorite
        ) {
          classement.push({
            date: toDateTimeCompact(item.date_publication),
            type: "actualite",
            data: item,
          });
        }
      });
    }

    if (alldatas.contributions) {
      alldatas.contributions.forEach((item) => {
        if (item.datePublication && toDateParseTCompact(item.datePublication) >= dateAnteriorite) {
          classement.push({
            date: toDateTimeCompact(item.datePublication),
            type: "contribution",
            data: item,
          });
        }
      });
    }

    if (alldatas.emissions) {
      alldatas.emissions.forEach((item) => {
        if (item.datePublication && toDateParseTCompact(item.datePublication) >= dateAnteriorite) {
          classement.push({
            date: toDateParseTCompact(item.datePublication),
            type: "emission",
            data: item,
          });
        }
      });
    }

    if (alldatas.publications) {
      alldatas.publications.forEach((item) => {
        if (item.datePublication && toDateParseTCompact(item.datePublication) >= dateAnteriorite) {
          classement.push({
            date: toDateParseTCompact(item.datePublication),
            type: "publication",
            data: item,
          });
        }
      });
    }

    classement.sort((b, a) => (a.date > b.date ? 1 : b.date > a.date ? -1 : 0));
    setDatas(classement);
    setLoader(false);
  };

  const renderItem = (affichage, objet, index) => {
    if (objet.type === "contribution" && ReduxInstance.espacePrincipalColidee !== 0) {
      return (
        <a
          href={
            process.env.REACT_APP_URL_COLIDEE +
            "o" +
            objet.data.id_entreprise +
            "p" +
            objet.data.id_plateforme +
            "/participation-" +
            objet.data.id_contribution +
            ".htm"
          }
          target="_blank"
          rel="noreferrer"
          key={"secondaire" + index}
          className="d-flex flex-nowrap mb-3"
        >
          <div
            className="blocIllustration"
            style={{
              backgroundImage: objet.data.illustrationSmall
                ? `url(` + objet.data.illustrationSmall + `)`
                : `url(` + process.env.REACT_APP_URL_COLIDEE + "img/medailloneasygouv.png" + `)`,
            }}
          ></div>
          <div className="contribution flex-grow-1">
            <div className="categorieArticles">
              {t("public.pageHome.categorieObjet8")}
              <span className="float-end">{toDateTimeFR(objet.data.datePublication)}</span>
            </div>
            <div className="identite">
              <Image src={objet.data.pictureColideur} className="m-1 rounded-circle avatar" />
              {objet.data.prenomColideur} {objet.data.nomColideur}
            </div>
            <ComponentThemesContribution contribution={objet.data} />
            {urlify(objet.data.contribution)}

            <div className="mt-2 nomPlateforme">
              {objet.data.nomPlateforme} <br />
              <BiMessageDetail size="1.5em" /> {objet.data.NbrContributions}
            </div>
          </div>
        </a>
      );
    }

    if (objet.type === "actualite" && ReduxInstance.modulesActives.includes("actualite")) {
      return (
        <a
          href={
            process.env.REACT_APP_URL_COLIDEE +
            "o" +
            objet.data.id_entreprise +
            "p" +
            objet.data.id_plateforme +
            "/detailactualite-" +
            objet.data.id_actualite +
            ".htm"
          }
          target="_blank"
          rel="noreferrer"
          key={affichage + "_" + index}
          className="d-flex flex-nowrap mb-3"
        >
          <div
            className="blocIllustration"
            style={{
              backgroundImage: objet.data.vignette
                ? `url(` + objet.data.vignette + `)`
                : `url(` + process.env.REACT_APP_URL_COLIDEE + "img/medailloneasygouv.png" + `)`,
            }}
          ></div>

          <div className="actualite flex-grow-1">
            <div className="categorieArticles">
              {t("public.pageHome.categorieObjet9")}
              <span className="float-end">{toDateTimeFR(objet.data.date_publication)}</span>
            </div>
            {objet.data.titre}
            <div className="mt-2 nomPlateforme">{objet.data.nom}</div>
          </div>
        </a>
      );
    }

    if (objet.type === "emission" && ReduxInstance.modulesActives.includes("emission")) {
      return (
        <a
          href={objet.data.URL}
          target="_blank"
          rel="noreferrer"
          key={affichage + "_" + index}
          className="d-flex flex-nowrap mb-3"
        >
          <div
            className="blocIllustration"
            style={{
              backgroundImage: illustrationVignette(objet.data),
            }}
          ></div>

          <div className="emission flex-grow-1">
            <div className="categorieArticles">
              {objet.data.type === "emission"
                ? t("public.pageHome.categorieObjet10")
                : t("public.pageHome.categorieObjet11")}
              <span className="float-end">{toDateParseFR(objet.data.datePublication)}</span>
            </div>
            <span className="fw-bold">{objet.data.nom}</span>
            <div className="p-1"> {objet.data.description}</div>
          </div>
        </a>
      );
    }

    if (objet.type === "publication" && ReduxInstance.modulesActives.includes("publication")) {
      return (
        <a
          href={objet.data.URL}
          target="_blank"
          rel="noreferrer"
          key={affichage + "_" + index}
          className="d-flex flex-nowrap mb-3"
        >
          <div
            className="blocIllustration"
            style={{
              backgroundImage: objet.data.cardPic
                ? `url(` +
                  process.env.REACT_APP_URL_EXPRESS +
                  "images/publication/small/" +
                  objet.data.cardPic +
                  `)`
                : `url(` + bandeauPublicationSmall + `)`,
            }}
          ></div>

          <div className="publication flex-grow-1">
            <div className="categorieArticles">
              {t("public.pageHome.categorieObjet12")}
              <span className="float-end">{toDateParseFR(objet.data.datePublication)}</span>
            </div>
            <span className="fw-bold">{objet.data.nom}</span>
            <div className="p-1"> {objet.data.description}</div>
          </div>
        </a>
      );
    }
  };

  const backgroundBandeauColidee = (illustrationContribution) => {
    if (illustrationContribution) return illustrationContribution;
    else return bandeauContribution;
  };

  const illustrationVignette = (objet) => {
    if (objet.cardPic) {
      return (
        `url(` + process.env.REACT_APP_URL_EXPRESS + "images/media/small/" + objet.cardPic + `)`
      );
    }

    if (objet.type === "emission") {
      const isOnYoutube = objet.URL.match("https://www.youtube.com/watch\\?v=");
      const urlThumbnail = objet.URL.replace("https://www.youtube.com/watch?v=", "");
      if (isOnYoutube)
        return `url(` + "https://i.ytimg.com/vi/" + urlThumbnail + "/hqdefault.jpg" + `)`;

      return `url(` + illustrationEmission + `)`;
    }

    if (objet.type === "podcast") {
      return `url(` + illustrationPodcast + `)`;
    }
  };

  useEffect(() => {
    if (ReduxInstance.modulesActives.includes("accueil4")) {
      filtreDatas();
    }
  }, [ReduxInstance, alldatas]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (ReduxInstance.modulesActives.includes("accueil4")) {
      setLoader(true);
      recupGlobal();
    }
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="hackHomeEthicsTransparent">
      {ReduxInstance.modulesActives.includes("accueil4") && (
        <>
          <ComponentTitleAndSousTitle title={t("public.pageHome.titleBloc4")} />
          {loader && <ComponentLoader />}
        </>
      )}
      <br />
      {(datas.length > 0 || focusPrimaire !== "" || focusSecondaire.length > 0) && (
        <>
          <div className="containerBlocEpingle  ">
            <div className="blocSecondaire d-flex  justify-content-between  flex-grow-2 ">
              {focusPrimaire && renderItem("principal", focusPrimaire, "fp")}
              {!focusPrimaire &&
                datas.slice(0, 1).map((objet, index) => renderItem("principal", objet, index))}
              {focusSecondaire.map((item, index) => renderItem("secondaire", item, "fs_" + index))}
              {datas
                .slice(
                  focusPrimaire ? 0 : 1,
                  focusPrimaire ? 2 - focusSecondaire.length : 3 - focusSecondaire.length
                )
                .map((objet, index) => renderItem("secondaire", objet, index))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BlocEpingle4;
